import { NavigateOptions, useNavigate } from "react-router-dom";
import { useEventId } from "./useEvent";

export const useEventNavigate = () => {
  const eventId = useEventId();
  const navigate = useNavigate();
  return (path: string, options?: NavigateOptions) => navigate(`/${eventId}${path}`, options);
};
